export type MediaKind = 'image' | 'audio' | 'video';

const MEDIA_PATTERNS: ReadonlyArray<readonly [MediaKind, RegExp]> = [
  ['image', /\.(png|jpe?g|gif|webp|svg|bmp)(\?.*)?$/i],
  ['audio', /\.(mp3|wav|ogg|m4a|aac)(\?.*)?$/i],
  ['video', /\.(mp4|webm|mov|ogv)(\?.*)?$/i],
];

const FILE_TYPE_GROUPS: ReadonlySet<string> = new Set<MediaKind>([
  'image',
  'audio',
  'video',
]);

export function detectMediaKind(
  source?: string | File | null,
): MediaKind | null {
  if (!source) return null;

  if (source instanceof File) {
    const [group] = source.type.split('/');
    return FILE_TYPE_GROUPS.has(group) ? (group as MediaKind) : null;
  }

  return MEDIA_PATTERNS.find(([, pattern]) => pattern.test(source))?.[0] ?? null;
}
